import React, { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, RotateCcw } from "lucide-react";
import { generateExclusions } from "../_shared";

export default function StepExclusions({ q, setQ }) {
  const [val, setVal] = useState("");
  const didAuto = useRef(false);

  useEffect(() => {
    if (didAuto.current) return;
    didAuto.current = true;
    if ((q.exclusions || []).length > 0) return;
    const suggestions = generateExclusions(q);
    if (suggestions.length) setQ((p) => ({ ...p, exclusions: suggestions }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const add = () => {
    if (!val.trim()) return;
    setQ((p) => {
      const exists = (p.exclusions || []).some((x) => x.toLowerCase() === val.trim().toLowerCase());
      if (exists) return p;
      return { ...p, exclusions: [...(p.exclusions || []), val.trim()] };
    });
    setVal("");
  };
  const rem = (i) => setQ((p) => ({ ...p, exclusions: p.exclusions.filter((_, idx) => idx !== i) }));
  const updItem = (i, v) => setQ((p) => ({ ...p, exclusions: p.exclusions.map((x, idx) => idx === i ? v : x) }));

  const regenerate = () => {
    const suggestions = generateExclusions(q);
    setQ((p) => {
      const existing = p.exclusions || [];
      const seen = new Set(existing.map((x) => x.toLowerCase()));
      const merged = [...existing];
      suggestions.forEach((s) => {
        if (!seen.has(s.toLowerCase())) { merged.push(s); seen.add(s.toLowerCase()); }
      });
      return { ...p, exclusions: merged };
    });
    toast.success("Exclusions refreshed");
  };

  return (
    <>
      <div className="flex gap-2">
        <input data-testid="exclusions-input" value={val} onChange={(e)=>setVal(e.target.value)} onKeyDown={(e)=>{ if (e.key==="Enter") add(); }}
          placeholder="e.g., Personal expenses, Travel insurance" className="flex-1 border border-border rounded px-3 py-2 text-sm" />
        <button data-testid="exclusions-add-btn" onClick={add} className="btn-bronze"><Plus size={15} /></button>
      </div>
      <div className="mt-3 flex items-center justify-between">
        <span className="text-xs text-slate-500">
          {(q.exclusions || []).length} item{(q.exclusions || []).length === 1 ? "" : "s"} — auto-filled, filtered against your Inclusions
        </span>
        <button data-testid="exclusions-regen-btn" onClick={regenerate} className="text-xs text-emerald-700 hover:underline flex items-center gap-1">
          <RotateCcw size={12} /> Regenerate suggestions
        </button>
      </div>
      <ul className="mt-3 space-y-1.5">
        {(q.exclusions || []).map((x, i) => (
          <li key={i} data-testid={`exclusions-item-${i}`} className="flex items-center gap-2 bg-slate-50 border border-border rounded px-3 py-2 text-sm">
            <input
              data-testid={`exclusions-edit-${i}`}
              value={x}
              onChange={(e) => updItem(i, e.target.value)}
              className="flex-1 bg-transparent outline-none"
            />
            <button data-testid={`exclusions-rem-${i}`} onClick={()=>rem(i)} className="text-red-500"><Trash2 size={13} /></button>
          </li>
        ))}
      </ul>
    </>
  );
}
